import { useEffect, useState } from 'react';
import { Box } from '@mui/material';

export default function HomepageTopAd({ adSpaceList }: { adSpaceList: any[] }) {
  const homepageAds = adSpaceList.filter(ad => ad.adPositionCode === 'homepage-top');
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (homepageAds.length > 1) {
      const interval = setInterval(() => {
        setCurrentIndex(prev => (prev + 1) % homepageAds.length);
      }, 3000);
      return () => clearInterval(interval);
    }
  }, [homepageAds]);

  return (
    <>
      {homepageAds.length > 0 && (
        <Box
          sx={{
            width: '100%',

            // 🚀 UPDATED HEIGHT HERE
            // xs (Mobile): Increased to 350px (was 250px)
            // sm (Tablet): 300px
            // md (Desktop): 320px
            height: { xs: 350, sm: 300, md: 320 },

            overflow: 'hidden',
            borderRadius: 2,
            position: 'relative',
            mx: 'auto',
            boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
          }}
        >
          <a
            href={homepageAds[currentIndex].adSpaceThumbnailUrl || '#'}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: 'block',
              width: '100%',
              height: '100%',
              position: 'absolute',
              top: 0,
              left: 0,
            }}
          >
            <img
              src={homepageAds[currentIndex].adSpaceImageUrl}
              alt={homepageAds[currentIndex].name || 'Advertisement'}
              style={{
                width: '100%',
                height: '100%',
                // Keep 'contain' so the full image shows, or switch to 'cover' 
                // if you want it to fill the box completely (but might crop edges)
                objectFit: 'contain', 
                objectPosition: 'center',
                display: 'block',
              }}
            />
          </a>
        </Box>
      )}
    </>
  );
}